import { Box, Button, Grid, Typography } from "@mui/material";
import Pictures from "../../../../Image/404.png";
import not_found from "../../../../Image/not_found.png";

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const PageNotFound: React.FC = () => {
  let history = useHistory();
  const [windowResize, setWindowResize] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWindowResize(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 12, // padding for small screens
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Left Side (Text) */}
        <Grid item xs={12} md={6}>
          <Box textAlign={windowResize <= 820 ? "center" : "left"}>
            <Typography
              sx={{
                color: "#0f3762",
                fontWeight: 100,
                fontSize: { xs: 28, md: 48 },
              }}
            >
              เกิดข้อผิดพลาด!
            </Typography>
            <Typography
              sx={{
                color: "#0f3762",
                fontWeight: 100,
                fontSize: { xs: 23, md: 26 },
              }}
            >
              ไม่สามารถเข้าใช้งานระบบได้ กรุณาเข้าสู่ระบบใหม่อีกครั้ง
            </Typography>
            <Box mt={2}>
              <Button
                sx={{
                  backgroundColor: "#0172B9",
                  borderColor: "#0172B9",
                  color: "white",
                  "&:hover": { backgroundColor: "#015a91" },
                }}
                onClick={() => history.goBack()}
              >
                ย้อนกลับ
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* Right Side (Image) */}
        <Grid item xs={12} md={6} display="flex" justifyContent="center">
          <img src={Pictures} alt="not_found" style={{ width: "100%", maxWidth: 1200 }} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PageNotFound;
